import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';

export const useClickJobPost = (jobPostId: number) =>
  useMutation({
    mutationFn: async () => {
      await fetchJson(`/job-posts/${jobPostId}/click`, {
        method: 'POST',
      });
    },
  });
